module.exports = __webpack_public_path__ + "img/vertical-left.d3baf0fb.svg";